'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // Let hash links (e.g. /games/stars/intro#practice-collections) scroll to their anchor instead of
    // yanking the page back to the top.
    if (window.location.hash) return;
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}
